/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const DELETE_ACTION_AI_CONTEXT_IMAGE = gql`
  mutation DeleteActionAiContextImage($id: ID!) {
    deleteActionAiContextImage(id: $id)
  }
`
